import { Middleware } from '@/legacy/OneRing';

const treatmentMapping = [Middleware.CreateMapping('Results', 'Results')];

function ConfigureMiddleware() {
    if (!Middleware.CheckMappingExists('TreatmentTypes', 'GET')) {
        Middleware.RegisterMapping('TreatmentTypes', 'GET', treatmentMapping);
    }
}

const TreatmentTypeData = {
    ConfigureMiddleware
};

export default TreatmentTypeData;
